import { BYE_ID } from './round-robin'

export function getNextPendingFixture(tournament) {
  return tournament.fixtures.find((fixture) => {
    if (fixture.status !== 'pending') {
      return false
    }
    return fixture.player1Identity && fixture.player2Identity
  }) || null
}

export function settleByes(tournament) {
  let changed = true
  while (changed) {
    changed = false
    tournament.fixtures.forEach((fixture) => {
      if (fixture.status !== 'pending') {
        return
      }

      const p1 = fixture.player1Identity
      const p2 = fixture.player2Identity
      if (!p1 || !p2) {
        return
      }

      if (p1 === BYE_ID && p2 === BYE_ID) {
        fixture.status = 'done'
        fixture.winnerIdentity = null
        changed = true
        return
      }

      if (p1 !== BYE_ID && p2 !== BYE_ID) {
        return
      }

      const winnerIdentity = p1 === BYE_ID ? p2 : p1
      fixture.status = 'done'
      fixture.winnerIdentity = winnerIdentity
      fixture.score1 = 0
      fixture.score2 = 0
      changed = true

      if (fixture.nextMatchId) {
        const nextMatch = tournament.fixtures.find((f) => f.id === fixture.nextMatchId)
        if (nextMatch) {
          if (fixture.nextSlot === 1) {
            nextMatch.player1Identity = winnerIdentity
          } else if (fixture.nextSlot === 2) {
            nextMatch.player2Identity = winnerIdentity
          }
        }
      }
    })
  }
}

export function applyKnockoutAdvance(tournament, result) {
  const fixture = tournament.fixtures.find((f) => f.id === result.fixtureId)
  if (!fixture) {
    return tournament
  }

  fixture.status = 'done'
  fixture.score1 = result.score1
  fixture.score2 = result.score2
  fixture.winnerIdentity = result.winnerIdentity

  if (fixture.nextMatchId) {
    const nextMatch = tournament.fixtures.find((f) => f.id === fixture.nextMatchId)
    if (nextMatch) {
      if (fixture.nextSlot === 1) {
        nextMatch.player1Identity = result.winnerIdentity
      } else if (fixture.nextSlot === 2) {
        nextMatch.player2Identity = result.winnerIdentity
      }
    }
  }

  settleByes(tournament)
  return tournament
}
